<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal.form-elem_short
        .form-elem__title Документ удостоверяющий личность
        .form-elem__main
          select.select(
          v-model="localDocType"
          @change="onChangeDocType($event)"
          )
            option(
            v-for="item in docTypeList"
            :value="item.value"
            ) {{item.text}}
    .form__elem(
      v-show="localDocType"
    )
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors.birth_certificate }"
      )
        .form-elem__title Номер
        .form-elem__main
          input.input(
            v-model="localBirthCertificate"
            @keyup="resetError('birth_certificate')"
            maxlength="16"
          )
    .form__elem(
    v-show="localDocType"
    )
      .form-elem.form-elem_horizontal.form-elem_short(
      :class="{ 'form-elem_error' : requireErrors.birth_certificate_attachments }"
      )
        .form-elem__title Копия
        .form-elem__main
          attach-file(
          :attachmentType="'birth_certificate'"
          :attachments="birthCertificateAttachments"
          :fieldname="'birth_certificate_attachments'"
          @onChangeAttachments="onChangeAttachments"
          )
    .form__elem(
      v-show="!localDocType"
    )
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors.passport }"
      )
        .form-elem__title Серия и номер
        .form-elem__main
          input.input(
            v-model="localPassport"
            @keyup="resetError('passport')"
            maxlength="11"
            v-mask="'#### ######'"
          )
    .form__elem.form__elem_short(
    v-show="!localDocType"
    )
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : requireErrors.passport_issue_date }"
      )
        .form-elem__title Дата выдачи
        .form-elem__main
          date-picker(
          placeholder="ДД.ММ.ГГГГ"
          v-model="localPassportIssueDate"
          format="DD.MM.YYYY"
          lang="ru"
          input-class="input"
          @change="onChangeDate($event)"
          :clearable="false"
          :editable="true"
          :not-after="new Date()"
          )
    .form__elem(
    v-show="!localDocType"
    )
      .form-elem.form-elem_horizontal.form-elem_short(
      :class="{ 'form-elem_error' : requireErrors.passport_attachments }"
      )
        .form-elem__title Копия
        .form-elem__main
          attach-file(
          :attachmentType="'passport'"
          :attachments="passportAttachments"
          :fieldname="'passport_attachments'"
          @onChangeAttachments="onChangeAttachments"
          )
    <!--.form__elem-->
      <!--.form-elem.form-elem_horizontal-->
        <!--.form-elem__title СНИЛС-->
        <!--.form-elem__main-->
          <!--input.input(-->
            <!--v-model="localSnils"-->
            <!--@keyup="resetError('snils')"-->
            <!--maxlength="14"-->
            <!--v-mask="'###-###-### ##'"-->
          <!--)-->
    <!--.form__elem-->
      <!--.form-elem.form-elem_horizontal.form-elem_short-->
        <!--.form-elem__title Копия СНИЛС-->
        <!--.form-elem__main-->
          <!--attach-file(-->
            <!--:attachmentType="'snils'"-->
            <!--:attachments="snilsAttachments"-->
            <!--:fieldname="'snils_attachments'"-->
            <!--@onChangeAttachments="onChangeAttachments"-->
          <!--)-->
    <!--.form__elem-->
      <!--.form-elem.form-elem_horizontal-->
        <!--.form-elem__title ИНН-->
        <!--.form-elem__main-->
          <!--input.input(-->
            <!--v-model="localInn"-->
            <!--@keyup="resetError('inn')"-->
            <!--maxlength="14"-->
            <!--v-mask="'####-######-##'"-->
          <!--)-->
    <!--.form__elem-->
      <!--.form-elem.form-elem_horizontal.form-elem_short-->
        <!--.form-elem__title Копия ИНН-->
        <!--.form-elem__main-->
          <!--attach-file(-->
            <!--:attachmentType="'inn'"-->
            <!--:attachments="innAttachments"-->
            <!--:fieldname="'inn_attachments'"-->
            <!--@onChangeAttachments="onChangeAttachments"-->
          <!--)-->
</template>

<script>
import DatePicker from "vue2-datepicker";
import AttachFile from "../../../../../components/attach-file/attach-file";

export default {
  name: "form-docs",
  components: {
    AttachFile,
    DatePicker,
  },
  props: {
    docType: {
      type: Boolean,
      default: false,
    },
    //паспорт
    passport: {
      type: [String, Number],
      default: "",
    },
    passportIssueDate: {
      type: [String, Object],
      default: null,
    },
    passportAttachments: {
      type: Array,
      default: () => [],
    },
    //свидетельство
    birthCertificate: {
      type: String,
      default: "",
    },
    birthCertificateAttachments: {
      type: Array,
      default: () => [],
    },
    //снилс
    snils: {
      type: String,
      default: "",
    },
    snilsAttachments: {
      type: Array,
      default: () => [],
    },
    //инн
    inn: {
      type: String,
      default: "",
    },
    innAttachments: {
      type: Array,
      default: () => [],
    },

    requireErrors: {
      type: Object,
      default: () => ({}),
    },
    resetError: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    localDocType: {
      get() {
        return this.docType;
      },
      set() {},
    },
    localBirthCertificate: {
      get() {
        return this.birthCertificate;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "birth_certificate"]);
      },
    },
    localPassport: {
      get() {
        return this.passport;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "passport"]);
      },
    },
    localPassportIssueDate: {
      get() {
        if (!this.passportIssueDate) {
          return "";
        }
        return this.passportIssueDate;
      },
      set() {},
    },
    localSnils: {
      get() {
        return this.snils;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "snils"]);
      },
    },
    localInn: {
      get() {
        return this.inn;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "inn"]);
      },
    },
  },
  data() {
    return {
      docTypeList: [
        {
          text: "Паспорт",
          value: false,
        },
        {
          text: "Свидетельство о рождении",
          value: true,
        },
      ],
    };
  },
  methods: {
    onChangeDocType(e) {
      this.$emit("onChangeDocType", e.target.value === "true");
    },
    onChangeDate(date) {
      const d = new Date(date);
      const _date = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
        -2
      )}-${("0" + d.getDate()).slice(-2)}`;
      this.$emit("onChangeValue", [_date, "passport_issue_date"]);
      this.resetError("passport_issue_date");
    },
    onChangeAttachments(fieldName) {
      // this.$emit("onChangeValue", [data.value, data.fieldname]);
      this.$emit("onChangeAttachments", fieldName);
    },
  },
};
</script>
